export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    ACUERDOS_REQUEST: 'ACUERDOS_GET_REQUEST',
    ACUERDOS_SUCCESS: 'ACUERDOS_GET_SUCCESS',
    ACUERDOS_FAILURE: 'ACUERDOS_GET_FAILURE',

    ACUERDO_REQUEST: 'ACUERDO_GET_REQUEST',
    ACUERDO_SUCCESS: 'ACUERDO_GET_SUCCESS',
    ACUERDO_FAILURE: 'ACUERDO_GET_FAILURE',

    SISTEMAS_REQUEST: 'SISTEMAS_GET_REQUEST',
    SISTEMAS_SUCCESS: 'SISTEMAS_GET_SUCCESS',
    SISTEMAS_FAILURE: 'SISTEMAS_GET_FAILURE',

    SISTEMA_SELECCIONADO: 'SISTEMA_SELECCIONADO',

    ORGANIZACIONES_REQUEST: 'ORGANIZACIONES_GET_REQUEST',
    ORGANIZACIONES_SUCCESS: 'ORGANIZACIONES_GET_SUCCESS',
    ORGANIZACIONES_FAILURE: 'ORGANIZACIONES_GET_FAILURE',

    RECUPERACLAVE_REQUEST: 'RECUPERACLAVE_GET_REQUEST',
    RECUPERACLAVE_SUCCESS: 'RECUPERACLAVE_GET_SUCCESS',
    RECUPERACLAVE_FAILURE: 'RECUPERACLAVE_GET_FAILURE',

    CONFIRMARCLAVE_REQUEST: 'CONFIRMARCLAVE_GET_REQUEST',
    CONFIRMARCLAVE_SUCCESS: 'CONFIRMARCLAVE_GET_SUCCESS',
    CONFIRMARCLAVE_FAILURE: 'CONFIRMARCLAVE_GET_FAILURE',
    
    CONFIRMATICKET_REQUEST: 'CONFIRMATICKET_GET_REQUEST',
    CONFIRMATICKET_SUCCESS: 'CONFIRMATICKET_GET_SUCCESS',
    CONFIRMATICKET_FAILURE: 'CONFIRMATICKET_GET_FAILURE',

    ORGANIZACION_SELECCIONADA: 'ORGANIZACION_SELECCIONADA',

    MENUPRINCIPAL_REQUEST: 'MENUPRINCIPAL_GET_REQUEST',
    
    LOGOUT: 'USERS_LOGOUT',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE'
};
